import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { NavLink } from 'react-router-dom';
import { XMarkIcon, Bars3Icon, GlobeAmericasIcon, ServerStackIcon, QueueListIcon } from '@heroicons/react/24/outline';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Sidebar = (props) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [navigation, setNavigation] = useState([
        { name: 'Consultar Cotizador', href: '/', icon: GlobeAmericasIcon, current: true },
        { name: 'Operaciones', href: '/operaciones', icon: QueueListIcon, current: false },
        { name: 'Listado de Vehículos', href: '/lista-carros', icon: ServerStackIcon, current: false },
        { name: 'Listado de Modelos', href: '/modelos', icon: ServerStackIcon, current: false },
        { name: 'Listado de Marcas', href: '/marcas', icon: ServerStackIcon, current: false },
    ]);

    const { children } = props;

    const SelectView = (selectedItem) => {
        setNavigation(prevNavigation =>
            prevNavigation.map(item => ({
                ...item,
                current: item.name === selectedItem.name ? true : false
            }))
        );
    };


    return (
        <div>
            <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog as="div" className="fixed inset-0 flex z-40 md:hidden" onClose={setSidebarOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-300 transform"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition ease-in-out duration-300 transform"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                    >
                        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-[#E6E6E6]">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-in-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in-out duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="absolute top-0 right-0 -mr-12 pt-2">
                                    <button
                                        type="button"
                                        className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                        onClick={() => setSidebarOpen(false)}
                                    >
                                        <span className="sr-only">Close sidebar</span>
                                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                    </button>
                                </div>
                            </Transition.Child>
                            <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                                <div className="flex-shrink-0 flex items-center px-4">
                                    <img
                                        className="h-8 w-auto"
                                        src="https://assets-global.website-files.com/60aea4e5ac6df65cf7e0b8a6/645cec6383c3c9419764c9d7_Group%20(1).png"
                                        alt="crabi"
                                    />
                                </div>
                                <nav className="mt-5 px-2 space-y-1">
                                    {navigation.map((item) => (
                                        <NavLink
                                            key={item.name}
                                            to={item.href}
                                            onClick={() => { SelectView(item) }}
                                            className={classNames(
                                                item.current ? '!bg-[#144DC9] !text-[#E6E6E6]' : '!text-gray-300 hover:!bg-[#DAE8FF] hover:!text-[#144DC9]',
                                                'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                                            )}
                                        >
                                            <item.icon
                                                className={classNames(
                                                    item.current ? '!text-gray-300' : '!text-gray-400 hover:!text-[#144DC9]',
                                                    'mr-4 flex-shrink-0 h-6 w-6'
                                                )}
                                                aria-hidden="true"
                                            />
                                            {item.name}
                                        </NavLink>
                                    ))}
                                </nav>
                            </div>
                        </div>
                    </Transition.Child>
                    <div className="flex-shrink-0 w-14">{/* La sidebar se encoje */}</div>
                </Dialog>
            </Transition.Root>

            {/* Sidebar Estatica */}
            <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                <div className="flex-1 flex flex-col min-h-0 bg-[#E6E6E6]">
                    <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                        <div className="flex items-center flex-shrink-0 px-4">
                            <img
                                className="h-8 w-auto"
                                src="https://assets-global.website-files.com/60aea4e5ac6df65cf7e0b8a6/645cec6383c3c9419764c9d7_Group%20(1).png"
                                alt="crabi"
                            />
                        </div>
                        <nav className="mt-5 flex-1 px-2 space-y-1">
                            {navigation.map((item) => (
                                <NavLink
                                    key={item.name}
                                    to={item.href}
                                    onClick={() => { SelectView(item) }}
                                    className={classNames(
                                        item.current ? '!bg-[#144DC9] !text-[#E6E6E6]' : '!text-[#144DC9] hover:!bg-[#DAE8FF] hover:!text-[#144DC9]',
                                        'group flex items-center px-2 py-2 text-sm font-medium rounded-md'
                                    )}
                                >
                                    <item.icon
                                        className={classNames(
                                            item.current ? '!text-gray-300' : '!text-[#144DC9] hover:!text-[#144DC9]',
                                            'mr-3 flex-shrink-0 h-6 w-6'
                                        )}
                                        aria-hidden="true"
                                    />
                                    {item.name}
                                </NavLink>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
            <div className="md:pl-64 flex flex-col flex-1">
                <div className="sticky top-0 z-10 md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-gray-100">
                    <button
                        type="button"
                        className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                        onClick={() => setSidebarOpen(true)}
                    >
                        <span className="sr-only">Open sidebar</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <main className="flex-1">
                    <div className="py-6">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                            <div className="py-4">
                                {children}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
};

export default Sidebar;
